import React from 'react';
import {
  Box, Button, Typography,
} from '@mui/material';
import { Trans } from '@gamiphy/react-i18n';
import { observer } from 'mobx-react';
import { ApplicableDiscountDiscount } from '@coretava/api/ecommerce-service';
import { CashbackPopupsStore } from '@gamiphy/loyalty-station-desktop/store/cashbackPopups';
import { getDiffInDays } from '@gamiphy/utils/date';
import freeShipping from './assets/freeShipping.png';

const FreeShippingDiscount: React.FC<{discount: ApplicableDiscountDiscount }> = ({ discount }) => (
  <Box display="flex" flexDirection="column" gap={1.5} textAlign="center">
    <Box component="img" src={freeShipping} alignSelf="center" mb={2} />
    <Typography fontSize="2.4rem" fontWeight={600}>
      <Trans
        i18nKey="cashbackPopup.discount.freeShipping.title"
        defaults="🚚 Free Shipping Just for You! 🎉✨"
      />
    </Typography>
    <Typography fontSize="1.6rem" color="#4F4F4F">
      <Trans
        i18nKey="cashbackPopup.discount.freeShipping.subtitle"
        defaults="Enjoy free shipping on your next order – No extra cost, just great savings!"
      />
    </Typography>
    <Button
      variant="contained"
      fullWidth
      onClick={() => CashbackPopupsStore.closeCashbackPopup()}
    >
      <Trans
        i18nKey="coreloyalty.cashback.shopNow"
        defaults="Shop now"
      />
    </Button>
    {discount.expiresAt && (
      <Typography fontSize="1.4rem" color="#344054" width="100%">
        <Trans
          i18nKey="discounts.bogo.validFor"
          defaults="Valid for {{validity}} days"
          values={{
            validity: getDiffInDays(new Date(discount.expiresAt), new Date()),
          }}
        />
      </Typography>
    )}
  </Box>
);

export default observer(FreeShippingDiscount);
